<ng-container rtBlock="sc-app-shell">
    <sc-app-header
        [currentLocale]="currentLocale"
        [ruHref]="ruHref()"
        [enHref]="enHref()"
        [compact]="isCalcRoute()"
        [activeStairType]="activeStairType()"
        [overVideo]="headerOverVideo()"
        [overlay]="headerOverlay()"
        (localeSelected)="onLocaleSelected($event)" />

    <main rtElem="main">
        <router-outlet />
    </main>

    @if (!isCalcRoute() && !isOrderRoute()) {
        <sc-app-footer />
    }

    <sc-cookie-banner />
    <rt-toaster position="top-right" />
    @defer (on idle(2000)) {
        <sc-visitor-chat qa-dataid="visitor-chat" />
    }
</ng-container>
